export default "__VITE_ASSET__DGWNG4jB__"